module.exports = __webpack_public_path__ + "static/unity-26a36f18f3bcf0ab0c2f8944874654bf.png";